const User = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99986 10.0001C12.301 10.0001 14.1665 8.1346 14.1665 5.83341C14.1665 3.53223 12.301 1.66675 9.99986 1.66675C7.69867 1.66675 5.83319 3.53223 5.83319 5.83341C5.83319 8.1346 7.69867 10.0001 9.99986 10.0001Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1583 18.3333C17.1583 15.1083 13.95 12.5 10 12.5C6.05001 12.5 2.84167 15.1083 2.84167 18.3333"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default User;
